import '@/svgsprite'
import { OccContext } from '@omnia/ui'
import { useLogger } from '@omnia/ui/src/lib/hooks/useLogger'
import { PagesRouter } from '@omnia/ui/src/lib/routing/PagesRouter'
import { sanitizeSiteTitle } from '@omnia/ui/src/lib/utils/strings/sanitizeSiteTitle'
import { defaultOccAssets } from '@vista-digital/occ-ui'
import { defaultOccSubcomponents } from '@vista-digital/occ-ui/src/lib/context/occ/types/subcomponents'
import { type FunctionComponent, useMemo } from 'react'
import { Helmet } from 'react-helmet-async'
import { changeOccContextDisplayText } from '@/common/occ-utils/changeOccContextDisplayText'
import { getCustomDomainConfig } from '@/common/occ-utils/getCustomDomainConfig'
import { getCustomOccConfig } from '@/common/occ-utils/getCustomOccConfig'
import { ModalUi } from './common/components/modalUIVersion15/ui'
import { cmsDataService } from './common/services/cms.data.service'
import { Layout } from './features/layout/Layout'

interface AppOverrideProps {
    pagesRouterOverride?: FunctionComponent
}

export const App: FunctionComponent<AppOverrideProps> = props => {
    const logger = useLogger('App')
    logger.info('App rendering', { loadTime: Date.now() - window.loadMs, version: APP_VERSION })

    const PagesRouterElement = useMemo(() => props.pagesRouterOverride ?? PagesRouter, [props.pagesRouterOverride])
    const occConfig = useMemo(() => getCustomOccConfig(), [])
    const browserConfig = useMemo(() => getCustomDomainConfig(), [])

    defaultOccAssets['carouselNextButtonIconName'] = 'arrow-right'
    defaultOccAssets['carouselPreviousButtonIconName'] = 'arrow-left'

    return (
        <OccContext
            changeOccContextDisplayText={changeOccContextDisplayText}
            config={occConfig}
            domain={browserConfig}
            occSubcomponents={{
                ...defaultOccSubcomponents, // Required to avoid type complaint
                Modal: ModalUi,
            }}
        >
            <Helmet>
                <title>{sanitizeSiteTitle(cmsDataService.get().siteTitle)}</title>
            </Helmet>
            <PagesRouterElement Layout={Layout} />
        </OccContext>
    )
}
